<template>
  <div class="context-item">
    <div v-for="(n, idx) in this.content" :key="idx">
      <!-- 图文单排版 -->
      <div v-if="n.type===1" class="wrapper">
        <el-row>
          <el-col :span="12" :xs="24">
            <div v-observe-visibility="textVisible" class="context-template-inside-internal pr bm--80 op-0 transition-slow">
              <div class="danger tt-u fs-14 context-little-title pr" style="letter-spacing: 3px;">{{n.littleTitle}}</div>
              <div class="serif context-title black mb-30">{{n.title}}</div>
              <div class="article-paragraph wordbreak">{{n.content}}</div>
            </div>
          </el-col>
          <el-col :span="12" class="ht-0">
            <span class="op-0 dis-ib ht-0">xx</span>
          </el-col>
        </el-row>
        <div class="pr context-template1-textbox" v-for="(item, index) in n.image" :key="index">
          <div class="pr">
            <img :src="item" class="wi-100x">
            <div v-observe-visibility="maskVisible" class="wi-100x ht-100x transition-lenear whitedark-bg pa tp-0 lf-0"></div>
          </div>
        </div>
      </div>
      <!-- 背景大图 -->
      <div v-else-if="n.type===2" class="context-template-interval" style="padding-left: 0px; padding-right: 0px;">
        <div class="pr">
          <img v-if="screenWidth>768" :src="n.image" class="wi-100x ht-100x">
          <div v-else :style="'background-image: url('+n.image+');'" class="centerimage ht-340"></div>
          <div v-observe-visibility="maskVisible" class="wi-100x ht-100x transition-lenear whitedark-bg pa tp-0 lf-0"></div>
        </div>
      </div>
      <!-- 引言转述 -->
      <div v-else-if="n.type==4" class="wrapper" >
        <div v-observe-visibility="textVisible" class="context-template-inside-internal transition-slow">
          <div class="context-template-einleitung-title serif">{{n.title}}</div>
          <div class="context-template-einleitung-subtitle pt-20 serif silver">{{n.subtitle}}</div>
        </div>
      </div>
      <!-- 图文双排版 -->
      <div v-else-if="n.type===3" class="wrapper">
        <!-- pc端 -->
        <div class="context-template-inside-internal" v-if="screenWidth>768">
          <el-row :gutter="80">
            <el-col :span="12">
              <div v-observe-visibility="textVisible" class="ht-500 pt-160 pr bm--80 op-0 transition-slow">
                <div class="danger tt-u fs-14 context-little-title pr" style="letter-spacing: 3px;">{{n.littleTitle}}</div>
                <div class="serif context-title black mb-30">{{n.title}}</div>
                <div class="article-paragraph wordbreak">{{n.content}}</div>
              </div>
              <div class="pr context-template-inside-internal" v-for="(item, index) in n.imagesLeft" :key="index">
                <img :src="item" class="wi-100x">
                <div v-observe-visibility="maskVisible" class="wi-100x ht-100x transition-lenear whitedark-bg pa tp-0 lf-0"></div>
              </div>
            </el-col>
            <el-col :span="12">
              <div class="pr context-template-inside-internal" v-for="(item, index) in n.imagesRight" :key="index">
                <img :src="item"
                  class="wi-100x">
                <div v-observe-visibility="maskVisible" class="wi-100x ht-100x transition-lenear whitedark-bg pa tp-0 lf-0"></div>
              </div>
            </el-col>
          </el-row>
        </div>
        <!-- 移动端 -->
        <div class="context-template-inside-internal" v-else>
          <el-row>
            <el-col :span="24">
              <div v-observe-visibility="textVisible" class="pr bm--80 op-0 transition-slow">
                <div class="danger tt-u fs-14 context-little-title pr" style="letter-spacing: 3px;">{{n.littleTitle}}</div>
                <div class="serif context-title black mb-30">{{n.title}}</div>
                <div class="article-paragraph wordbreak">{{n.content}}</div>
              </div>
              <div class="pr mb-20" v-for="(item, index) in n.imagesLeft" :key="index">
                <img :src="item" class="wi-100x">
                <div v-observe-visibility="maskVisible" class="wi-100x ht-100x transition-lenear whitedark-bg pa tp-0 lf-0"></div>
              </div>
            </el-col>
            <el-col :span="24">
              <div class="pr mb-20" v-for="(item, index) in n.imagesRight" :key="index">
                <img :src="item" class="wi-100x">
                <div v-observe-visibility="maskVisible" class="wi-100x ht-100x transition-lenear whitedark-bg pa tp-0 lf-0"></div>
              </div>
            </el-col>
          </el-row>
        </div>
      </div>
      <!-- 文字模板 -->
      <div v-else-if="n.type==6" class="wrapper">
        <div>
          <el-row>
            <el-col :span="12" :xs="24">
              <div v-observe-visibility="textVisible" class="context-template1-textbox pr bm--80 op-0 transition-slow">
                <div class="danger tt-u fs-14 context-little-title pr" style="letter-spacing: 3px;">{{n.littleTitle}}</div>
                <div class="serif context-title black mb-30">{{n.title}}</div>
                <div class="article-paragraph wordbreak">{{n.content}}</div>
              </div>
            </el-col>
            <el-col :span="12" class="ht-0">
              <span class="op-0 dis-ib ht-0">xx</span>
            </el-col>
          </el-row>
        </div>
      </div>
      <!-- 图文视频 -->
      <div v-else-if="n.type==5" class="wrapper">
        <div>
          <el-row>
            <el-col :span="12" :xs="24">
              <div v-observe-visibility="textVisible" class="context-template-inside-internal pr bm--80 op-0 transition-slow">
                <div class="danger tt-u fs-14 context-little-title pr" style="letter-spacing: 3px;">{{n.littleTitle}}</div>
                <div class="serif context-title black mb-30">{{n.title}}</div>
                <div class="article-paragraph wordbreak">{{n.content}}</div>
              </div>
            </el-col>
            <el-col :span="12" class="ht-0">
              <span class="op-0 dis-ib ht-0">xx</span>
            </el-col>
          </el-row>
        </div>
        <div v-for="(it, index) in n.image" :key="index" class="context-template1-textbox pr cur-p show-image-action wi-100x ht-a graylight-bg centerimage">
          <video :poster="it.cover" muted controls class="wi-100x mb-20">
            <source :src="it.url" type="video/mp4">
          </video>
          <div v-observe-visibility="maskVisible" class="wi-100x ht-100x transition-lenear whitedark-bg pa tp-0 lf-0"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  props: ['content'],
  name: 'Context',
  data () {
    return {
    }
  },
  computed: {
    ...mapGetters([
      'screenHeight',
      'screenWidth'
    ]),
    height () {
      var res = ''
      if (this.screenWidth >= 1200) {
        res = 'height: ' + this.screenHeight * 0.8 + 'px;'
      } else {
        res = 'height: auto;'
      }
      return res
    }
  },
  methods: {
    textVisible (isVisible, entity) {
      if (isVisible) {
        setTimeout(() => {
          entity.target.style.opacity = 1
          entity.target.style.bottom = 0
        }, 500)
      }
    },
    maskVisible (isVisible, entity) {
      if (isVisible) {
        entity.target.style.height = 0
      }
    },
    imageVisible (isVisible, entity) {
      if (isVisible) {
        entity.target.firstElementChild.style.height = '100%'
      }
    }
  }
}
</script>
<style>
/* 模块内部间隔 */
.context-template-inside-internal {
  margin-bottom: 30px;
  padding-left: 20px;
  padding-right: 20px;
}
.context-little-title {
  margin-bottom: 10px;
}
.article-little-title {
  font-size: 13px;
  margin-bottom: 8px;
}
.context-title {
  font-size: 1.625em;
}
.article-paragraph wordbreak {
  color: #333333;
  font-size: 16px;
  line-height: 28px;
  margin-bottom: 30px;
}
/* 图文单排版文字模块 */
.context-template1-textbox {
  padding-bottom: 20px;
  padding-left: 20px;
  padding-right: 20px;
}
/* 模板之间的间隔 */
.context-template-interval {
  margin-bottom: 80px;
  padding-left: 20px;
  padding-right: 20px;
}
/* 距离顶部 */
.context-item {
  margin-top: 0px;
}
/* 引言标题 */
.context-template-einleitung-title {
  font-size: 1.625em;
}
/* 引言副标题 */
.context-template-einleitung-subtitle {
  font-size: 1em;
}
@media screen and (min-width: 768px) and (max-width: 992px) {
  .article-little-title {
    font-size: 14px;
    margin-bottom: 5px;
  }
  /* 模块内部间隔 */
  .context-template-inside-internal {
    margin-bottom: 100px;
  }
  .context-title {
    font-size: 28px;
  }
  /* 图文单排版文字模块 */
  .context-template1-textbox {
    padding-bottom: 120px;
  }
  /* 模板之间的间隔 */
  .context-template-interval {
    margin-bottom: 120px;
  }
  /* 距离顶部 */
  .context-item {
    margin-top: 50px;
  }
  /* 引言标题 */
  .context-template-einleitung-title {
    font-size: 35px;
    padding-top: 30px;
  }
  /* 引言副标题 */
  .context-template-einleitung-subtitle {
    font-size: 18px;
    padding-bottom: 40px;
  }
}
@media screen and (min-width: 992px) and (max-width: 1200px) {
  .article-little-title {
    font-size: 14px;
    margin-bottom: 10px;
  }
  /* 模块内部间隔 */
  .context-template-inside-internal {
    margin-bottom: 100px;
  }
  .context-title {
    font-size: 32px;
  }
  /* 图文单排版文字模块 */
  .context-template1-textbox {
    padding-bottom: 120px;
  }
  /* 模板之间的间隔 */
  .context-template-interval {
    margin-bottom: 120px;
  }
  /* 距离顶部 */
  .context-item {
    margin-top: 100px;
  }
  /* 引言标题 */
  .context-template-einleitung-title {
    font-size: 40px;
    padding-top: 50px;
  }
  /* 引言副标题 */
  .context-template-einleitung-subtitle {
    font-size: 20px;
    padding-bottom: 60px;
  }
}
@media screen and (min-width: 1200px) and (max-width: 1920px) {
  .article-little-title {
    font-size: 15px;
    margin-bottom: 10px;
  }
  /* 模块内部间隔 */
  .context-template-inside-internal {
    padding-left: 0;
    padding-right: 0;
    margin-bottom: 80px;
  }
  .context-title {
    font-size: 38px;
  }
  /* 图文单排版文字模块 */
  .context-template1-textbox {
    padding-bottom: 60px;
    padding-left: 0;
    padding-right: 0;
  }
  /* 模板之间的间隔 */
  .context-template-interval {
    margin-bottom: 120px;
  }
  /* 距离顶部 */
  .context-item {
    margin-top: 150px;
  }
  /* 引言标题 */
  .context-template-einleitung-title {
    font-size: 45px;
    padding-top: 70px;
  }
  /* 引言副标题 */
  .context-template-einleitung-subtitle {
    font-size: 22px;
    padding-bottom: 90px;
  }
}
@media screen and (min-width: 1920px) {
  .article-little-title {
    font-size: 16px;
    margin-bottom: 20px;
  }
  /* 模块内部间隔 */
  .context-template-inside-internal {
    margin-bottom: 60px;
    padding-left: 0;
    padding-right: 0;
  }
  .context-title {
    font-size: 46px;
  }
  /* 图文单排版文字模块 */
  .context-template1-textbox {
    padding-bottom: 60px;
    padding-left: 0;
    padding-right: 0;
  }
  /* 模板之间的间隔 */
  .context-template-interval {
    margin-bottom: 120px;
  }
  /* 距离顶部 */
  .context-item {
    margin-top: 200px;
  }
  /* 引言标题 */
  .context-template-einleitung-title {
    font-size: 50px;
    padding-top: 80px;
  }
  /* 引言副标题 */
  .context-template-einleitung-subtitle {
    font-size: 24px;
    padding-bottom: 60px;
  }
}
</style>



// WEBPACK FOOTER //
// src/compos/Context.vue